import { Tab, TabGroup, TabList, TabPanel, TabPanels } from '@headlessui/react';
import { twMerge } from 'tailwind-merge';
import PersonalPanel from './PersonalPanel';
import TablePanel from './TablePanel/TablePanel';
import useIsMobileView from '../../../../hooks/useIsMobileView';
import SecurityPanel from './SecurityPanel';
import useGetTaleSettings from '@/services/user/queries/useGetTaleSettings';
import ReferralsPanel from './ReferralsPanel';
import { useState } from 'react';
import AddWalletModal from '@/features/user-profile/profile-settings/components/AddWalletModal';
import Modal from '@/components/Modal/Modal';
import styles from './SettingsModal.module.css';

const settingsTabs: string[] = ['Personal', 'Table', 'Security', 'Referrals'];

interface SettingsModalProps {
  onClose: () => void;
  isOpen: boolean;
}

const SettingsModal = ({ onClose, isOpen }: SettingsModalProps) => {
  const isMobileView = useIsMobileView();
  useGetTaleSettings(); //We do this to fetch and cache before tableSettings opens
  const [showAddWalletModal, setShowAddWalletModal] = useState(false);

  if (showAddWalletModal) {
    return (
      <AddWalletModal
        open={showAddWalletModal}
        onClose={() => {
          setShowAddWalletModal(false);
        }}
      />
    );
  }

  return (
    <>
      <Modal
        bodyClassName="overflow-y-auto scrollbar-phenom scrollbar-track-transparent scrollbar-thumb-ph-primary-violet"
        open={isOpen}
        setClose={onClose}
        className={twMerge(
          'box-content flex',
          isMobileView
            ? 'h-full w-full'
            : 'max-h-[min(740px,calc(100vh-50px))] min-h-[min(740px,calc(100vh-50px))] min-w-[min(600px,calc(100vw-50px))] max-w-[min(600px,calc(100vw-50px))]',
        )}
        titleComponent={<Modal.Title onClose={onClose} title="Settings" />}
      >
        <TabGroup>
          <TabList
            className={twMerge(
              'mb-5 flex w-full',
              isMobileView && 'overflow-auto scrollbar scrollbar-track-transparent scrollbar-thumb-ph-primary-violet',
            )}
          >
            {settingsTabs.map((tab) => (
              <Tab className="w-full focus:outline-none" key={tab}>
                {({ selected }) => (
                  <span
                    className={twMerge(
                      'block w-full border-b border-b-ph-gray-evening px-6 py-3 font-manrope text-base font-bold text-ph-gray-evening',
                      selected && 'border-b-2 border-ph-primary-violet text-ph-primary-violet',
                      !selected && styles.tab,
                      // "hover:text-ph-primary-violet hover:border-ph-primary-violet hover:bg-gradient-to-t hover:from-[rgba(169,88,215,0.2)] hover:to-transparent",
                    )}
                  >
                    {tab.toUpperCase()}
                  </span>
                )}
              </Tab>
            ))}
          </TabList>
          <TabPanels className="custom-scroll flex-1 overflow-y-auto">
            <TabPanel className="focus:outline-none">
              <PersonalPanel setShowAddWalletModal={setShowAddWalletModal} />
            </TabPanel>
            <TabPanel className="focus:outline-none">
              <TablePanel />
            </TabPanel>
            <TabPanel className="focus:outline-none">
              <SecurityPanel />
            </TabPanel>
            <TabPanel className="focus:outline-none">
              <ReferralsPanel />
            </TabPanel>
          </TabPanels>
        </TabGroup>
      </Modal>
    </>
  );
};

export default SettingsModal;
